export enum UploadTypeEnum {
  Scorm = 'scorm',
  File = 'file',
  WebLink = 'webLink',
}
